
export default {
  "m": {
    "sms_login": "Connexion par message court",
    "get_vercode": "Envoyer",
    "change_mobile": "Changer de numéro de téléphone",
    "log_reg_agree": "Se connecter/s'inscrire signifie accepter {msg_ss}",
    "old_mobile": "Numéro de téléphone d'origine",
    "new_mobile": "Nouveau numéro de téléphone",
    "agency_reginfo_fill": "Remplissez les informations d'inscription de la guilde",
    "audit_res": "Résultats des audits",
    "agency_name": "Nom de guilde",
    "agency_name_input": "Veuillez entrer un nom de guilde",
    "agency_name_input_note": "Remarque : il est recommandé que le nom de la guilde soit court et facile à retenir, pas plus de 30 mots",
    "agency_logo": "LOGO de la guilde",
    "agency_logo_unpload_note": "Veuillez télécharger un LOGO de guilde clair au format PNG/JPG/JPEG",
    "agency_contact_name": "Personne de contact de la guilde",
    "user_contact_name": "Veuillez renseigner le nom de la personne qui est en contact quotidien avec la plateforme utilisateur",
    "agency_contact_phone": "Numéro de téléphone de la guilde",
    "agency_whatsapp": "Chef de guilde WhatsApp",
    "agency_whatsapp_contact": "Veuillez entrer les coordonnées WhatsApp du chef de guilde",
    "agency_use_lang": "Langue utilisée par le chef de guilde",
    "agency_head_ID": "ID de chef de guilde",
    "agency_ID_input": "Veuillez entrer l'ID utilisateur du chef de guilde BuzzCast APP pour une distribution ultérieure des fonds",
    "reg_country": "Pays d'immatriculation",
    "inhand_ID_photo": "Pièce d'identité avec photo en main",
    "upload_note_t": "Considérations relatives au téléchargement",
    "agency_self_inhand_ID": "Il doit être porté par l'agent lui-même avec le document de passeport",
    "photo_must_clearly": "La face avant doit clairement montrer la personne et les véritables informations du passeport en prenant une photo",
    "mian_form_country": "Le principal pays d'origine de l'hôte",
    "invite_code": "Code d'invitation",
    "your_profile_submit_success": "Votre document a été soumis avec succès ! nous nous en occuperons dès que possible.<br>Les résultats de l'audit seront envoyés à la notification BuzzCast APP du chef de guilde, et veuillez faire attention à vérifier !",
    "your_profile_approved": "Le document que vous avez soumis n'a pas passé l'examen ! La raison du rejet est que la photo du passeport en possession n'est pas claire\".<br>Veuillez remplir à nouveau ou contacter l'assistant officiel sur BuzzCastAPP pour consultation.",
    "return_refill": "Revenir en arrière et remplir",
    "success_agency": "Félicitations pour votre installation réussie de la plate-forme, [cliquez sur moi] pour commencer à travailler !",
    "personal_account": "Compte personnel",
    "my_agency": "Ma guilde",
    "your_agency_been_forcibly": "Votre guilde a été fermée de force par la plateforme, et vous ne pourrez plus vous connecter au système.<br>Si vous avez des questions, veuillez contacter l'assistant officiel de BuzzCastAPP ou l'opération exclusive.",
    "invite_live_join": "Inviter l'hôte à rejoindre le lien de la guilde",
    "base_info": "Informations de base",
    "apply_time": "Date de la demande",
    "join_time": "Temps d'adhésion",
    "cooper_status": "Statut de coopération",
    "streamer_manage": "Gestion des hôtes",
    "sereamer_apply": "Approbation de l'hôte",
    "sereamer_nickname": "Pseudonyme de l'hôte",
    "remark": "Remarque",
    "no_remark": "Aucune remarque",
    "add_remark": "Ajouter des remarques",
    "birth": "Date de naissance",
    "user_status": "Statut de l'utilisateur",
    "temporarily_frozen": "Gel temporaire",
    "permanently_frozen": "Geler pour toujours",
    "fans_num": "Nombre d'abonnés",
    "sign_status": "Statut du contrat",
    "sign_ing": "Sous contrat",
    "sign_time": "Date de contrat",
    "release_time": "Date d'annulation",
    "live_viola_record": "Dossiers de violation de diffusion en direct",
    "sign_record": "Dossier de contrat",
    "current_contract_status": "Statut actuel du contrat",
    "termination_reason": "Raison de la résiliation",
    "violation_reason": "Raison de la violation",
    "violation_time": "Date de l'infraction",
    "processing_result": "Résultat du processus",
    "exported_data": "Exporter des données",
    "join_agency_apply": "Approbation pour rejoindre la guilde",
    "audit_status": "Statut approuvé",
    "pending_review": "En attendant l'examen",
    "pending_HQ_review": "En attente d'examen par le siège",
    "not_approved_HQ": "Non approuvé par le bureau central",
    "withdrawn": "Révoqué",
    "audit_trail": "Examiner les enregistrements",
    "oper": "Fonctionnement",
    "other_video_materials": "Autres documents vidéo",
    "pass": "Passer",
    "pass_streamer_join_agency_apply": "Passer l'application pour que l'hôte rejoigne la guilde",
    "reject_streamer_join_agency_apply": "Rejeter la demande pour que l'hôte rejoigne la guilde",
    "agree_streamer_join_agency": "Acceptez l'ancre {msg_ss1} pour devenir un expéditeur sous {msg_ss2}~",
    "reject_streamer_join_agency": "La candidature du membre {msg_ss1} pour devenir membre de {msg_ss2} est rejetée !",
    "img_material": "Documents photographiques",
    "approver": "Approbateur",
    'user_enter_bind_phone': 'Veuillez entrer le numéro de téléphone',
    'vericode': 'Code de vérification',
    'input_vericode': 'Veuillez saisir le code de vérification',
    'login': 'S\'identifier',
    'reg': 'Inscrit',
    'logout': 'Déconnexion',
    'search_for': 'Recherche',
    'subscription_closed': 'Contrat annulé',
    'agency_ID': 'Code de guilde : {msg_ss}',
    'reset': 'Refaire avec',
    'live_ID': 'ID de diffuseur',
    'live_record': 'Enregistrement d\'écran de diffusion en direct',
    'email': 'Adresse mail',
    'phone': 'Phone',
    'mastery_lang': 'Langue de maître',
    'to': 'À',
    'cancel': 'Annuler',
    'Confirm': 'Oui',
    'preview': 'Aperçu',
    'rejected': 'Rejeté',
    'tip': 'Invite',
    'i_got_it': 'Je l\'ai',
    'cancelled': 'Annulé',
    'refused': 'Refuser',
    'agency_agree': 'La guilde a accepté',
    'platform_agree': 'La plate-forme a accepté',
    'user_not_exist': 'Cet utilisateur n\'existe pas',
    'user_frozen': 'Cet utilisateur est gelé',
    'reviewing': 'En revue',
    'review_pass': 'Examen passé',
    'review_failed': 'Échec de l’audit',
    'xx_hours': '{msg_ss} heures',
    'xx_days': '{msg_ss} jours',
    'xx_hour': '{msg_ss} heure',
    'xx_day': '{msg_ss} jour',
    'xx_year': '{msg_ss} an',
    'xx_years': '{msg_ss} ans',
    'check_phone_istrue': 'Veuillez vérifier si le numéro de téléphone est entré correctement',
    'male': 'Male',
    'female': 'Gemme',
    'avatar': 'Portrait',
    'normal': 'Normal',
    'live_room': 'Salle de diffusion en direct',
    'view': 'View',
    'oper_success': 'Opération réussie',
    'copy_success': 'Copie réussie',
    'new_mobile_already_reg': 'Le nouveau numéro de mobile est enregistré',
    'general_user': 'Utilisateur général',

    'copy': 'Copie',
    'gender': 'Genre',
    'submit': 'Soumettre',
    'permanent': 'Permanent',
    'agree_agreement': 'Accepter et respecter le contrat',
    'vericode_error': 'Le code de vérification est erroné',
    'resend': 'supprimer mes goût',
    'approved': 'Passer',
    'not_approved': 'Échec du passage',
    'agency_rejected': 'Plate-forme rejetée',
    'select': 'choisir',
    'search': 'Rechercher',
    'rejection_reason': 'Raison du rejet',
    'no_data': 'Aucune donnée',
    'oper_failed': 'L\'opération a échoué',
    'leave_agency_apply': 'Approbation pour le retrait de la guilde',
    'over_word_limit': 'Dépassement de la limite de mots',
    'delete': 'Supprimer',
    'nickname': 'Pseudo',
    'file_is_too_large': 'Fichier trop volumineux',

    'community_convention': 'Convention communautaire Buzzcast',
    'approval_time': 'Délai d\'approbation',
    'guild_system_title': 'Système de guilde de la plate-forme sociale BuzzCast',
    'return': 'Retour',
    'img_upload_fail': 'Échec du téléchargement de l\'image',
    'cooper_ing': 'En coopération',
    'upload_file_format_incorrect': 'Le fichier téléchargé n\'est pas au bon format',
    'token_invalid': 'Le jeton n\'est pas valide, veuillez vous reconnecter!',
    'network_busy': 'Le réseau est occupé, veuillez réessayer',
    'minute': '{msg_ss}minute',

    'live_room_ID': 'ID de la salle de diffusion en direct',
    'scan_code': 'Scannez le code pour vous connecter à BuzzCast',
    'open_code': 'Ouvrez l’application et cliquez sur mon QR code pour le scanner',
    'refresh': 'Rafraîchir',
    'login_confirm': 'La confirmation de connexion',
    'account': 'Confirmation du login',
    'user_name': 'Nom de l’utilisateur',
    'edit': 'Modification',
    'changing': 'Changer le nombre lié',
    'mobile_number': 'Numéro de compte de téléphone portable',
    'mobile_login': 'Vous pouvez vous connecter avec votre numéro de téléphone portable {msg_ss}.',
    'appId_login': 'Vous pouvez scanner et vous connecter avec un compte avec AppID de [{msg_ss}].',
    'code_login': 'L\'identifiant BuzzCastApp n\'est pas lié, vous pouvez scanner le code QR pour vous connecter après avoir été lié',
    'verification_log': 'Le numéro de téléphone portable n\'est pas lié. Après la liaison, vous pouvez vous connecter avec le numéro de téléphone portable et le code de vérification.',
    'binding_success': 'Liaison réussie',
    'binding_mobile': 'Lier le numéro de téléphone portable',
    'edit_name': 'Modifier le nom d\'utilisateur',
    'binding_alert': 'Rappel du changement contraignant',
    'new_appId': 'L\'ID APP original sera directement remplacé si le nouvel ID APP est utilisé pour scanner le code de liaison',
    'binding_account': 'Lier le compte de l\'application BuzzCast',
    'anchor_earings': 'Le revenu de l\'ancre',
    'signing_date': 'Date de signature',
    'statistical_date': 'Date statistique',
    'valid_min': 'Durée totale de validité (minute)',
    'valid_day': 'Date de validité (jours)',
    'total_revenue': 'Revenu total',

    'bind': 'Bind',
    'please_agree_agree': 'Veuillez accepter le contrat',
    'note': 'Remarque : L\'heure affichée par ce système est l\'heure de New York (EST)',
    'app_phone': 'Enregistrez le numéro de téléphone mobile de l\'APP',
    'host_num': 'Nombre d\'hôtes',
    'enter_host_num': 'Veuillez entrer son numéro de tous les hôtes',
    'platform': 'Plateforme de coopération',
    'statement': 'Relevé bancaire mensuel',
    'enter_income': 'Veuillez entrer le revenu mensuel moyen',
    'check_commas': 'Format incorrect. Veuillez vérifier si les multiples plates-formes sont séparées par des virgules',
    'submit_success': 'Votre document a été soumis avec succès! nous nous en occuperons dès que possible',
    'usd': 'USD',
    'many_platforms': 'Veuillez entrer la plate-forme de diffusion en direct avec laquelle vous avez déjà coopéré, jusqu\'à 20 plates-formes',
    'limit_platform': 'Jusqu\'à 20 plateformes',
    'user_has_delete': 'L\'utilisateur a été annulé',
    'cant_commit': 'Vous êtes déjà un diffuseur sous contrat et vous ne pouvez pas demander une guilde pour vous installer en même temps',
    'cant_commit_1': 'Vous avez déjà postulé avec un diffuseur sous contrat et vous ne pouvez pas postuler pour une guilde pour vous installer en même temps',
    'passwd': 'Mot de passe',
    'passwd_placeholder': 'Votre code doit contenir de 6 à 20 caractères',
    'live_rights': 'Évaluation sans temps',
    'edit_log': 'Changer d\'enregistrement',
    'edit_time': 'Modifier l\'heure',
    'edit_pwd': 'Changer le mot de passe',
    'old_pwd': 'Ancien mot de passe',
    'new_pwd': 'Nouveau mot de passe',
    'confirm_pwd': 'Confirmer le mot de passe',
    'forget_pwd': 'Oubliez de votre code?',
    'email_check': 'Le format du courrier électronique est incorrect',
    'phone_pwd_error': 'Numéro de téléphone ou code incorrect',
    'ten_min_error': 'Veuillez réessayer dans 10 minutes',
    'phone_bind_error': 'Le numéro de téléphone mobile a été lié à d\'autres comptes, veuillez remplacer le nouveau numéro de téléphone mobile à associer.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'L\'ID du chef de guilde a déjà été renseigné, veuillez le remplir à nouveau',
    'pwd_error': 'Mot de passe incorrect',
    'phone_not_reg_error': 'Le compte n\'est pas enregistré',
    'pwd_nq': 'Les nouveaux mots de passe entrés sont incohérents',
    'sign_anchor_error': 'Vous êtes déjà un diffuseur sous contrat et vous ne pouvez pas demander une guilde pour vous installer en même temps',
    'apply_anchor_error': 'Vous avez déjà postulé avec un diffuseur sous contrat et vous ne pouvez pas postuler pour une guilde pour vous installer en même temps',
    'have-expired': 'Expiré',
    'approval-time': 'Délai de traitement',
    'reasons-for-refusal': 'Veuillez saisir le motif du refus',
    'Transfer-grounds': 'Raisons du transfert',
    'code_expire': 'Le code de vérification a expiré. Cliquez sur le code de vérification pour le mettre à jour.',
    'transfer-approval': 'Approbation du transfert',
    'live_state_placeholder': 'Statut in vivo',
    'live_state_open': 'Normal',
    'live_state_temporary_banned': 'Absence de consentement',
    'live_state_forever_banned': 'Interdiction permanente',
    'live_allowed_time': 'Heure de début autorisée',
    'live_banned_time': 'Période d\'interdiction',
    'deduct_money': 'Déduire le montant des pièces B',
    'final_income': 'Revenu réel',
    'select_start_dt': 'Veuillez sélectionner une heure de début',
    'select_end_dt': 'Veuillez sélectionner une heure de fin',
    'less_then_end_dt': 'L\'heure de début doit être inférieure ou égale à l\'heure de fin',
    'System_automatically_through': 'Le système passe automatiquement',
    'btrade_err': 'L\'identifiant de l\'agence n\'est pas disponible',

    'mouth_anchor': 'Présentateur avec salaire mensuel',
    'day_anchor': 'Présentateur avec salaire journalier',
    'guild_anchor': 'Récompense du chef de guilde (salaire journalier)',
    'mouth_anchor_st': 'Date de début du salaire mensuel',
    'mouth_anchor_et': 'Date de fin du salaire mensuel',
    'day_anchor_st': 'Date de début du salaire journalier',
    'day_anchor_et': 'Date de fin du salaire journalier',
    'all_award_bcoin': 'Total des gains de la récompense du salaire journalier',
    'live_hour': 'Récompense de la durée effective en direct',
    'salary_day': 'Date',
    'day_in_come': 'Gains de la guilde ce jour (pièces B)',
    'award_ration_flag_str': 'Ratio de récompense',
    'payable_money': 'Récompense en pièces B du chef de guilde',
    'host_bcoins': 'Pièces B gagnées par présentateur',
    'total_official': 'Total des pièces B récompensées par officiel ',
    'actual_bcoins_awarded': 'Pièces B réellement récompensées',
    "change_bound_account":"Changer de compte lié" ,
    "agent_id_form":"ID du chef de guilde :" ,
    "BuzzCast_verification_code":"Code de vérification BuzzCast :" ,
    "send_success":"Envoyer réussi" ,
    "account_changed_successfully":"Le compte lié a été modifié avec succès." ,
    "invite_guild_url":"Invitation à devenir chef de guilde BuzzCast : {msg_ss}" ,
    "invite_guild_code":"Mon code d'invitation : {msg_ss}" ,
    "save":"Enregistrer" ,
    "compile":"Modifier" ,
    "agent_nvitation_eward":"Récompenses d'invitation du chef de guilde" ,
    "agent_name":"Surnom du chef de guilde" ,
    "guild_id":"Code de la guilde" ,
    "guild_income_30days":"Gains de la guilde au cours des 30 derniers jours" ,
    "guild_invite_income_30days":"Gains d'invitation de guildes au cours des 30 derniers jours" ,
    "agency_commission_ratio":"Taux de Commission de l'Agence" ,
    "invite_income_bcoins":"L'invitation récompense les pièces B" ,
    "id_not_exist": "Cet identifiant n'existe pas",
    'reward_distribution_status': 'Statut de distribution des récompenses',
    'must_number': 'Votre saisie doit être au format purement numérique.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/fr.js